<template>
  <v-card flat tile>
    <v-window v-model="onboarding">
      <v-window-item v-for="(a, index) in project.apps" :key="index">
        <app-card :project="project" :boilerplates="boilerplates" :clusters="clusters" :types="types" :app="a" v-on="$listeners" />
      </v-window-item>
    </v-window>

    <v-card-actions class="justify-space-between">
      <v-btn
        text
        @click="prev"
      >
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-item-group
        v-model="onboarding"
        class="text-center"
        mandatory
      >
        <v-item
          v-for="n in project.apps.length"
          :key="`btn-${n}`"
          v-slot="{ active, toggle }"
        >
          <v-btn
            :input-value="active"
            icon
            @click="toggle"
            x-small
          >
            <v-icon x-small>circle</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-btn
        text
        @click="next"
      >
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppCard from './AppCard.vue'

export default {
  props: {
    project: {
      type: Object,
      require: true
    },
    boilerplates: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    },
    clusters: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    },
    types: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    }
  },
  components: {
    AppCard
  },
  data: () => ({
    onboarding: 0,
    // Repositório da app em foco. O índice não serve para isso: a lista é
    // substituída a cada atualização e a mesma app pode mudar de posição.
    focused: null
  }),
  mounted () {
    this.synchronize()
  },
  computed: {
    apps () {
      return this.project.apps || []
    }
  },
  methods: {
    // O card sobrevive à atualização (a lista de projetos é indexada por '_id'),
    // então o carrossel continua onde estava enquanto a lista por baixo é trocada.
    // Reencontra a app em foco pelo repositório e avisa o pai, para que o menu e
    // os botões do card não passem a agir sobre outra app.
    synchronize () {
      if (!this.apps.length) return

      const index = this.focused ? this.apps.findIndex(a => a.repository === this.focused) : -1

      const target = index >= 0 ? index : 0

      // Sem mudança de posição não há o que avisar: emitir aqui a cada
      // atualização faria o pai se redesenhar inteiro uma vez por projeto.
      if (target === this.onboarding) return

      this.onboarding = target
    },
    next () {
      this.onboarding = this.onboarding + 1 >= this.apps.length ? 0 : this.onboarding + 1
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0 ? this.apps.length - 1 : this.onboarding - 1
    }
  },
  watch: {
    onboarding (newValue) {
      const app = this.apps[newValue]

      this.focused = app ? app.repository : null

      this.$emit('highlight', this.project.unix, newValue)
    },
    'project.apps' () {
      this.synchronize()
    }
  }
}
</script>
